import { Lock, ShieldCheck, EyeOff } from "lucide-react";
import { useLang } from "@/i18n";
import { Reveal } from "@/components/Reveal";

export default function Confidentiality() {
  const { t } = useLang();
  const icons = [EyeOff, Lock, ShieldCheck];
  const marqueeItems = [...t.confidentiality.marquee, ...t.confidentiality.marquee];

  return (
    <section id="confidentiality" className="relative py-24 lg:py-32 bg-[#0A0F20] overflow-hidden grain" data-testid="confidentiality-section">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,rgba(212,175,55,0.07),transparent_60%)]" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 lg:gap-20 items-center">
          <div>
            <Reveal>
              <p className="text-xs font-mono uppercase tracking-[0.28em] text-gold/80 mb-5">{t.confidentiality.overline}</p>
            </Reveal>
            <Reveal delay={0.08}>
              <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-medium leading-tight text-slate-100" data-testid="confidentiality-title">
                «&nbsp;<span className="italic gold-text">{t.confidentiality.title}</span>&nbsp;»
              </h2>
            </Reveal>
            <Reveal delay={0.16}>
              <p className="mt-8 text-base sm:text-lg text-slate-400 font-light leading-relaxed">{t.confidentiality.text}</p>
            </Reveal>
          </div>
          <div className="space-y-4">
            {t.confidentiality.points.map((p, i) => {
              const Icon = icons[i];
              return (
                <Reveal key={i} delay={0.1 + i * 0.12}>
                  <div data-testid={`confidentiality-point-${i}`} className="flex items-start gap-5 border hairline rounded-sm bg-obsidian-surface/70 backdrop-blur-md p-6 hover:border-gold/40 transition-colors duration-500">
                    <span className="mt-0.5 w-10 h-10 shrink-0 flex items-center justify-center border border-gold/40 rounded-full text-gold">
                      <Icon size={17} strokeWidth={1.5} />
                    </span>
                    <p className="text-sm sm:text-base text-slate-300 font-light leading-relaxed">{p}</p>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </div>

      {/* Editorial marquee */}
      <div className="relative mt-24 border-y hairline py-6 overflow-hidden" data-testid="brand-marquee">
        <div className="flex w-max animate-marquee whitespace-nowrap">
          {marqueeItems.map((m, i) => (
            <span key={i} className="flex items-center">
              <span className="font-serif italic text-2xl sm:text-3xl lg:text-4xl text-transparent px-8" style={{ WebkitTextStroke: "1px rgba(212,175,55,0.35)" }}>
                {m}
              </span>
              <svg width="26" height="16" viewBox="0 0 26 16" className="shrink-0 opacity-40">
                <path d="M1 13 H25" stroke="#D4AF37" strokeWidth="1" />
                <path d="M5 13 C 9 5, 17 5, 21 13" stroke="#D4AF37" strokeWidth="0.8" fill="none" />
              </svg>
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
